import { PageListCachedDataSource } from './BaseDataSources';
import { IAssetClass } from '../Interfaces';

export class AssetClassSource extends PageListCachedDataSource<IAssetClass> {
  public constructor() {
    super('/datasource/assetclasses');
  }
}